<div class="ro-spin tw-text-center mt-{{ margin }} mb-{{ margin }} fadeIn animated" [ngClass]="{'ro-spinner-contrast': contrast}">
  <span class="ro-spinner"></span>
  <p class="message m-1">{{ message }}</p>
</div>
